





import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import SdsMobileHeader from '@src/app/mobile/navbar/SdsMobileHeader.vue';
import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import { AccountRoutes } from '@superbet-group/web.types';
import SocialMobileHeader from '@src/app/mobile/navbar/SocialMobileHeader.vue';

export default defineComponent({
    name: 'AccountMobileHeader',
    setup() {
        const { route } = useVueRouter();

        const isMySocialRoute = computed(() => route.value.name === AccountRoutes.MySocial);

        return {
            isMySocialRoute,
        };
    },
    components: {
        SdsMobileHeader,
        SocialMobileHeader,
    },
});
